export enum ResolvedReason {
    ResolvedSpokenDirect = "Spoken with child",
    ResolvedExternal = "External issue has been resolved",
    ResolvedOther = "A third reason",
}
